import {
  MatchResultGoals,
  MatchResultMatchTeamGoals,
  MatchResultModel,
  MatchResultScored,
  MatchResultScoredNull,
  UmpireIncident,
  UmpireMatch,
  UmpireSoccerMatchHalf,
  UmpireSquad,
} from '@tisa-group/models';

export type MatchOverallIncident =
  | 'match_started'
  | 'half_time'
  | 'match_ended'
  | 'second_half_started';

const addGoal = (
  pScoredGoalHost: MatchResultMatchTeamGoals,
  pScoredGoalGuest: MatchResultMatchTeamGoals,
  scoredGoal: UmpireIncident,
  squad: UmpireSquad,
): MatchResultScoredNull => {
  const isHost = scoredGoal.squad.id === squad.id;
  const pScoredGoal: MatchResultMatchTeamGoals = isHost
    ? pScoredGoalHost
    : pScoredGoalGuest;
  const newGoal = {
    goals: scoredGoal ? pScoredGoal.goals.concat(scoredGoal) : pScoredGoal.goals,
    total: scoredGoal ? pScoredGoal.total + 1 : pScoredGoal.total,
  };
  const hostGoal = isHost ? newGoal : null;
  const guestGoal = !isHost ? newGoal : null;

  return {
    hostGoal,
    guestGoal,
  };
};
export const getGoals = (
  match: UmpireMatch,
  occurrence: number,
  half: UmpireSoccerMatchHalf,
): MatchResultGoals => {
  const incidents = match.incidents
    .slice()
    .filter(incident => {
      if (half === 1) {
        return incident.occurrence_half === 1 && incident.occurrence_minute <= occurrence;
      }

      return incident.occurrence_half === 1 || incident.occurrence_minute <= occurrence;
    })
    .sort((a: UmpireIncident, b: UmpireIncident) => {
      if (a.occurrence_half < b.occurrence_half) {
        return -1;
      }

      if (
        a.occurrence_half === b.occurrence_half &&
        a.occurrence_minute < b.occurrence_minute
      ) {
        return -1;
      }

      return 0;
    })
    .reduce(
      (previousValue: MatchResultModel, incident: UmpireIncident) => {
        const {
          scored: {hostGoal: pScoredGoalHost, guestGoal: pScoredGoalGuest},
          incidents: pIncidents,
        } = previousValue;
        let goals: MatchResultScoredNull = {guestGoal: null, hostGoal: null};

        switch (incident.incident_type) {
          case 'goal':
          case 'penalty':
            if (incident.verification_status !== 'var_disallowed') {
              goals = addGoal(
                pScoredGoalHost,
                pScoredGoalGuest,
                incident,
                match.home_squad,
              );
            }
            break;
          case 'own_goal':
            if (incident.verification_status !== 'var_disallowed') {
              goals = addGoal(
                pScoredGoalHost,
                pScoredGoalGuest,
                incident,
                match.away_squad,
              );
            }
            break;
        }

        const scored: MatchResultScored = {
          hostGoal: goals.hostGoal ? goals.hostGoal : pScoredGoalHost,
          guestGoal: goals.guestGoal ? goals.guestGoal : pScoredGoalGuest,
        };

        return {
          scored,
          incidents: pIncidents.concat({incident, scored}),
        };
      },
      {
        scored: {hostGoal: {goals: [], total: 0}, guestGoal: {goals: [], total: 0}},
        incidents: [],
      },
    );

  return {
    incidents: {...incidents, incidents: (incidents?.incidents || []).reverse()},
    data: match,
  };
};
